const RUT_VALIDATION_ERROR_MESSAGE = 'Invalid RUT'

function isRUTValid(rut: string): boolean {
    if (!rut) return false
    if (rut.split('-')[1]?.length > 1) return false
    const cleanRUT = rut.replace(/[^0-9a-z]/gi, '')
    const checkDigit = [...cleanRUT].slice(-1)[0]
    const withoutCheckDigitRUT = cleanRUT.slice(0, -1)
    if (isNaN(Number(withoutCheckDigitRUT)) || withoutCheckDigitRUT.length < 7)
        return false

    if (cleanRUT == '123456789') return false

    if (/^(.)\1*$/.test(cleanRUT)) return false

    const obtainedCheckDigit = getCheckDigit(withoutCheckDigitRUT)

    return checkDigit.toLowerCase() === obtainedCheckDigit.toLowerCase()
}

function rutValidator(rut: string): boolean | string {
    return isRUTValid(rut) || RUT_VALIDATION_ERROR_MESSAGE
}

function getCheckDigit(rutInput: string) {
    let rut = Number(rutInput)
    let M = 0
    let S = 1
    for (; rut; rut = Math.floor(rut / 10))
        S = (S + (rut % 10) * (9 - (M++ % 6))) % 11
    return S ? String(S - 1) : 'K'
}

// Date in format DD/MM
const dateRegex = new RegExp(
    /^(0[1-9]|[12][0-9]|30(?!\/02)|31(?!\/(0[2469]|11)))\/(0[1-9]|1[0-2])$/
)

const isDateValid = (date: string): boolean => dateRegex.test(date)

// Full date in format YYYY-MM-DD (native <input type="date"> value)
const birthDateRegex = new RegExp(
    /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
)

const isBirthDateValid = (date: string): boolean => birthDateRegex.test(date)

// min 8 characters with both letters and numbers
const passwordRegex = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)
const isPasswordValid = (password: string): boolean =>
    passwordRegex.test(password)

export {
    isRUTValid,
    isDateValid,
    isBirthDateValid,
    isPasswordValid,
    rutValidator
}
